import {FeedbackBase} from "../component/FeedbackBase";

export const FeedbackRes = () => <FeedbackBase/>